import React from "react";

export type PaymentMethodConfirmSummarySection = {
  label: string;
  content: React.ReactNode;
};

interface PropsInterface {
  sections: PaymentMethodConfirmSummarySection[];
  className?: string;
}

export const PaymentMethodConfirmSummary: React.FC<PropsInterface> = ({
  sections,
  className = "",
}) => {
  if (sections.length === 0) {
    return null;
  }

  return (
    <div className={`autopay-confirm-summary ${className}`.trim()}>
      <div className="autopay-confirm-summary-card">
        {sections.map((section, index) => (
          <div
            key={section.label}
            className={
              index === 0 ? undefined : "autopay-confirm-summary-payment-method"
            }
          >
            <div className="autopay-confirm-summary-label">{section.label}</div>
            {section.content}
          </div>
        ))}
      </div>
    </div>
  );
};
